export default __webpack_public_path__ + "static/media/twinstarProtect.655683fd.jpg";